<template>
  <div id="container" class="container">
    <Navigator class="section"></Navigator>
    <CarouselNew class="section" :style="{height: height}"></CarouselNew>
    <ProductCenter class="section" :style="{height: height}"></ProductCenter>
    <CustomerOpinions class="section" :style="{height: height}"></CustomerOpinions>
    <ContactUs class="section" place="index" :style="{height: height}"></ContactUs>
    <EnFooter class="section"></EnFooter>
  </div>
</template>
<script>
  import Navigator from 'src/components/Navigator';
  import EnFooter from 'src/components/EnFooter';
  import CarouselNew from './CarouselNew';
  import ProductCenter from './ProductCenter';
  import CustomerOpinions from './CustomerOpinions';
  import ContactUs from 'src/components/ContactUs';

  export default {
    name: 'app',
    components: {
      Navigator,
      EnFooter,
      CarouselNew,
      ProductCenter,
      CustomerOpinions,
      ContactUs,
    },
    created() {
      let height = this.visibleHeight();
      if (height < 700) {
        height = 700;
      } else if (height > 1080) {
        height = 1080;
      }
      this.height = `${height}px`;

      console.log('created');
      // window.addEventListener('mousewheel', this.mouseWheelHandler, false);
    },
    data() {
      return {
        index: 1,
        height: 1024,
        scrollings: [],
        prevTime: new Date().getTime(),
      }
    },
    methods: {
      visibleHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
      },
      mouseWheelHandler(e) {
        e.preventDefault();
        const curTime = new Date().getTime();

        // cross-browser wheel delta
        e = window.event || e || e.originalEvent;

        const value = e.wheelDelta || -e.deltaY || -e.detail;
        const delta = Math.max(-1, Math.min(1, value));
        window.scroll(0, window.scorllY + value);
        console.log('value', value);
        console.log('delta', delta);
        if (this.scrollings.length > 149) {
          this.scrollings.shift();
        }

        //keeping record of the previous this.scrollings
        this.scrollings.push(Math.abs(value));
        const timeDiff = curTime - this.prevTime;
        this.prevTime = curTime;
        if (timeDiff > 200) {
          //emptying the array, we dont care about old scrollings for our averages
          this.scrollings = [];
        }


        var averageEnd = this.getAverage(this.scrollings, 10);
        var averageMiddle = this.getAverage(this.scrollings, 70);
        console.log(averageEnd, averageMiddle, this.scrollings);
        var isAccelerating = averageEnd >= averageMiddle;

        if (isAccelerating) {
          //scrolling down?
          if (delta < 0) {
            console.log('down');
            this.scrolling('down');

            //console.log up?
          } else {
            console.log('up');
          }
        }

        return true;
      },
      scrolling(type) {
        // // debugger;
        // console.log(window.scrollY);
        // // window.scrollY = window.scrollY + this.height;
        // window.scroll(0, window.scrollY + this.height);
        // // if (type == 'down') {
        // //   moveSectionDown();
        // // } else {
        // //   moveSectionUp();
        // // }
        let height;
        if (type === 'down') {
          this.index++;
          // height = `-${this.height * this.index}px`;
        } else {
          this.index--;
        }
        height = `-${this.height * this.index}px`;
        document.querySelectorAll('.section').forEach(a => {
          a.style.transform = `translate3d(0, ${height}, 0)`;
        });
      },
      getAverage(elements, number) {
        let sum = 0;

        //taking `number` elements from the end to make the average, if there are not enought, 1
        const lastElements = elements.slice(Math.max(elements.length - number, 1));

        for (let i = 0; i < lastElements.length; i++) {
          sum = sum + lastElements[i];
        }
        return Math.ceil(sum / number);
      }
    },
  };
</script>
<style>

</style>


// WEBPACK FOOTER //
// app.vue?610e21c3